import "./styles/Skeleton.scss";

export const GifPreviewPlaceholder = () => <div className="GifPreviewPlaceholder" />;
export const GifBlockPlaceholder = () => <div className="tile GifBlockPlaceholder" />;
export const NicheBlockPlaceholder = () => <div className="NichePreview NicheBlockPlaceholder" />;
export const CreatorTilePlaceholder = () => <div className="CreatorTile CreatorTilePlaceholder" />;
export const TagPlaceholder = () => <div className="TagPlaceholder" />;
